import React from 'react';
import imgGetStarted from '../../assets/img/getStartedBtn.png';
import styled from 'styled-components/macro';

const Label = styled.div`
  margin-bottom: 24px;
  font-weight: bold;
  font-size: 1.1em;
`;

const LaunchGame = ({
  label = 'Join FREE for 30 days',
  width = 185,
  paddingTop = 20,
  paddingBottom = 20,
  labelStyle = {fontSize: 28},
  ...props
}) => (
  <div style={{ marginTop: 24, marginBottom: 24, ...props.style }} {...props}>    
    <a href="https://brainquakegames.com/bqapp/index.html ">
      <img src={imgGetStarted} alt="BQ app" style={{ width, paddingTop, paddingBottom }} />
    </a>
    {label.length > 0 && <Label style={labelStyle}>{label}</Label>}
  </div>
);

export default LaunchGame;
